(function () {
  $(function () {
    var $input, tmpInput;
    $input = $('#input');
    tmpInput = "a\tb\tc\n1\t2\t3\n4\t5\t6\n";
    $input.val(tmpInput);
    let $output = $('#output');
    const StringToReplace = "zFNz";
    const RegExFnStringifyWorkaround = new RegExp('"?' + StringToReplace + '"?', "g");

    function parseCsvIntoJSON(sInput) {
      var arrRowSplit,
        arrTmp,
        col,
        headers,
        i,
        j,
        k,
        len,
        len1,
        output,
        ref,
        tmp,
        val;
      arrTmp = sInput.split("\n");
      headers = arrTmp.shift();
      output = [];
      for (j = 0, len = arrTmp.length; j < len; j++) {
        val = arrTmp[j];
        if (val === "") {
          continue;
        }
        tmp = {};
        arrRowSplit = val.split("\t");
        ref = headers.split("\t");
        var RegBoolean = /^(true|false)$/i;
        for (i = k = 0, len1 = ref.length; k < len1; i = ++k) {
          col = ref[i];
          if (typeof arrRowSplit[i] === "undefined") {
            continue;
          }
          var fParsed = parseFloat(arrRowSplit[i]);
          if (!isNaN(fParsed)) {
            tmp[col] = fParsed;
          } else if (RegBoolean.test(arrRowSplit[i])) {
            tmp[col] = arrRowSplit[i].match(RegBoolean)[1].toLowerCase() === "true";
          } else if (/^fn/.test(arrRowSplit[i])) {
            tmp[col] = StringToReplace + arrRowSplit[i] + StringToReplace;
          } else if (arrRowSplit[i].length === 0) {
            continue;
          } else {
            tmp[col] = arrRowSplit[i];
          }
        }
        if (Object.keys(tmp).length > 0) {
          output.push(tmp);
        }
      }
      return output;
    }


    return $('#convert').click(function () {
      var arrRowSplit, arrTmp, col, headers, i, j, k, len, len1, numRegex, output, ref, tmp, val;
      tmp = $('#input').val();
      // arrTmp = tmp.split('\n');
      // headers = arrTmp.shift();
      // output = [];
      // for (j = 0, len = arrTmp.length; j < len; j++) {
      //   val = arrTmp[j];
      //   // ignore blanks
      //   if (val === '') {
      //     continue;
      //   }
      //   tmp = {};
      //   arrRowSplit = val.split('\t');
      //   ref = headers.split('\t');
      //   for (i = k = 0, len1 = ref.length; k < len1; i = ++k) {
      //     col = ref[i];
      //     numRegex = /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/;
      //     if (numRegex.test(arrRowSplit[i])) {
      //       tmp[col] = parseFloat(arrRowSplit[i]);
      //     } else {
      //       tmp[col] = arrRowSplit[i];
      //     }
      //   }
      //   output.push(tmp);
      // }
      // return $('#output').val(JSON.stringify(output));

      let aParsedOut = parseCsvIntoJSON(tmp);
      $output.val(JSON.stringify(aParsedOut).replace(RegExFnStringifyWorkaround, ""));
    });
  });

}).call(this);
